export function filenameToLanguage(filename: string): string | undefined {
  const fileNameLower = filename.toLowerCase();
  if (fileNameLower.endsWith('.js') || fileNameLower.endsWith('.jsx')) {
    return 'javascript';
  } else if (fileNameLower.endsWith('.html') || fileNameLower.endsWith('.htm')) {
    return 'html';
  } else if (fileNameLower.endsWith('.css')) {
    return 'css';
  } else if (fileNameLower.endsWith('.py')) {
    return 'python';
  } else if (fileNameLower.endsWith('.json')) {
    return 'json';
  } else if (fileNameLower.endsWith('.xml')) {
    return 'xml';
  } else if (fileNameLower.endsWith('.txt')) {
    return 'text';
  }
  return undefined;
}
